//$.fn.datepicker.defaults.language = 'lt';
var xfileinput = function () { };

xfileinput.prototype = {
  init: function (el) {
    //debugger;
    var me = this;
    me.el = el;
    me.parent = el.closest("div.xfileinput");
    me.input = me.parent.find("input.xfileinput-upload-filename");
    me.hidden = me.input.next("input");
    me.real = me.parent.find("input:last");
    me.required = me.real.prop("required");
    me.label = me.parent.find("label.xfileinput-btn-c");
    me.del = me.parent.find("a.file_delete");
    me.download = me.del.prev("a");

    if (me.input.val() && me.required) {
      me.real.prop("required", false);
    }

    el.on("change", function (e) {
      me.onAddedFiles(this.files);
      me.del.show();
      me.real.prop("required", false);
      $(me.el).valid();
    });

    me.del.on("click", function (e) {
      me.onFileDelete();
    });

    return me;
  },
  onFileDelete: function () {
    var me = this;

    me.input.val("");
    me.hidden.val("del");
    me.real.val("");
    if (me.required) {
      me.real.prop("required", true);
    }

    me.label.removeClass("d-none");
    me.download.hide();
    me.del.hide();
  },
  onAddedFiles: function (files) {
    var me = this,
      values = Object.keys(files).map(function (e) {
        return files[e];
      });

    me.updateInput(values);
  },
  updateInput: function (files) {
    var me = this,
      input = me.input,
      text = "failų",
      len = files.length;

    if (len === 1) {
      text = files[0].name;
    } else if (len === 0) {
      text = "";
    } else if (len > 0 && len < 10) {
      text = "pasirinkti " + len + " failai";
    } else {
      text = "pasirinkta " + len + " failų";
    }

    input.val(text);
  },
  getPreview: function (file, f, div) {
    var el = div.find("img.preview-img");
    if (f.img === true) {
      var reader = new FileReader();
      reader.addEventListener(
        "load",
        function () {
          el[0].src = reader.result;
        },
        false
      );

      return reader.readAsDataURL(file);
    } else {
      return;
    }
  },
  getFileAttributes: function (file) {
    var me = this;
    var obj = {
      name: file.name,
      ext: file.name.split(".").pop(),
      type: file.type,
      date: file.lastModified,
      size: file.size,
      img: file.type.indexOf("image") !== -1,
    };
    return obj;
  },
};

function range(start, end, step) {
  var foo = [];
  for (var i = start; i <= end; i += step) {
    foo.push(i);
  }
  return foo;
}

var xtime2 = function () { };

xtime2.prototype = {
  KEY: "xtime2",
  init: function (el) {
    var me = this;
    me.el = el;

    var val = el.val();

    if (val && moment(val).isValid()) {
      // 2016-12-01 16:11 --> 16:11
      val = moment(val).format("HH:mm");
    } else if (val && moment.duration(val).isValid()) {
      // 16:11:01 --> 16:11
      // asHours del to jog gali nurodyti 24:00, tada `hours` grazina 0
      val = Math.floor(moment.duration(val).asHours()) + ":" + moment.duration(val).minutes();
    }

    if (val !== "" && $.isNumeric(val.replace(":", ""))) {
      me.inputvalid(val.split(":"));
    } else if (!$.isNumeric(val.replace(":", ""))) {
      me.setval();
    }

    me.eventsset();

    return this;
  },
  eventsset: function () {
    var me = this,
      el = me.el;

    el.on("focus." + xtime2.prototype.KEY, function (ev) {
      if (me.dropdown) {
        $(document).click();
        return;
      }
      if ($._data($(document)[0], "events").click) {
        $(document).click();
      }

      ev.stopPropagation();
      me.setdropdown();

      me.dropdown.on("click", function (e) {
        e.stopPropagation();
      });

      $(document).one("click.xtime2", function () {
        me.dropdown.remove();
        delete me.dropdown;
      });

      me.dropdown.on("remove", function () {
        $(document).off("click.xtime2");
      });
      el.parent().removeClass("input-wrong wrong-over wrong-format");
    })
      .on("click." + xtime2.prototype.KEY, function (e) {
        e.stopPropagation();
      })
      .on("keyup." + xtime2.prototype.KEY, function (e) {
        if (e.keyCode == 86) {
          el.trigger("keypress");
        }
      })
      .on("keypress." + xtime2.prototype.KEY, function (key) {
        if (key.charCode < 48 || (key.charCode > 57 && key.charCode != 58)) {
          return false;
        }
        el.off("blur." + xtime2.prototype.KEY);
        el.one("blur." + xtime2.prototype.KEY, function () {
          var value = el.val(),
            time = value.split(":");
          if (value === "") {
            return false;
          } else if (!$.isNumeric(value.replace(":", ""))) {
            el.parent().addClass("input-wrong wrong-format");
            me.setval();
            return false;
          }
          me.inputvalid(time);
        });
      });
  },
  /**
   * @param {array} time
   * @param {boolean} change
   */
  setval: function (time, change) {
    var me = this,
      value =
        time === undefined ?
          "" :
          me.stringType(time[0]) + ":" + me.stringType(time[1]);

    me.el.val(value);
    me.time = time;

    if (change) {
      me.el.trigger("change", time);
    }
  },
  setdropdown: function () {
    var me = this,
      el = me.el,
      div = el.parent(),
      meX = div.offset().left,
      meY = div.offset().top + div.outerHeight(),
      meWidth = div.outerWidth(),
      min_h = el.attr("data-min"),
      data_min1 =
        String(el.attr("data-min")).indexOf(":") > -1 ?
          el.attr("data-min", min_h) :
          el.attr("data-min", min_h + ":00"),
      data_min = el.attr("data-min") || "00:00",
      max_h = el.attr("data-max"),
      data_max1 =
        String(el.attr("data-max")).indexOf(":") > -1 ?
          el.attr("data-max", max_h) :
          el.attr("data-max", max_h + ":00"),
      data_max = el.data("max") || "23:59",
      step = el.data("step") ? me.intType(el.data("step")) : 10,
      min = me.intType(data_min.split(":")),
      max = me.intType(data_max.split(":")),
      xt,
      hrs = range(min[0], max[0], 1),
      mns = range(0, 59, step),
      html1 = "",
      html2 = "",
      value = el.val() ? me.intType(el.val().split(":")) : [-1, -1];

    console.log(data_max);

    $.each(hrs, function (index, h) {
      html1 +=
        '<a href="javascript:;" ' +
        (value[0] == h ? 'class="active"' : "") +
        ">" +
        h +
        "</a>";
    });
    $.each(mns, function (index, m) {
      html2 +=
        '<a href="javascript:;" ' +
        (value[1] == m ? 'class="active"' : "") +
        ">" +
        m +
        "</a>";
    });

    xt =
      "" +
      '<div class="xt-xtime" style="top: ' +
      meY +
      "px; left: " +
      meX +
      "px; width: " +
      meWidth +
      'px;">' +
      '<div class="xt-xtime-wrap">' +
      '<a href="javascript:;" class="close">' +
      '<i class="fa fa-fw fa-times"></i>' +
      "</a>" +
      '<div class="time">' +
      '<div class="xt-label">Valandos</div>' +
      '<div class="hours xt-picker">' +
      html1 +
      "</div>" +
      '<div class="xt-label">Minutės</div>' +
      '<div class="minutes xt-picker">' +
      html2 +
      "</div>" +
      "</div>" +
      "</div>" +
      "</div>";

    $("body").append(xt);
    me.dropdown = $("div.xt-xtime");

    me.dropdownEvents();
    me.disableMin();
  },
  dropdownEvents: function () {
    var me = this,
      dropdown = me.dropdown,
      hours = dropdown.find("div.hours > a"),
      minutes = dropdown.find("div.minutes > a");

    dropdown
      .find(".hours")
      .add(dropdown.find(".minutes"))
      .mousewheel(function (e, d) {
        e.preventDefault();
        e.currentTarget.scrollLeft -= d * 30;
      });

    hours.on("click", function (e) {
      var a = $(e.currentTarget);
      if (a.hasClass(".active")) {
        return;
      }
      var time = me.time || [0, 0];
      time[0] = me.intType(a.text());

      me.setval(time, true);
      me.disableMin();
      a.siblings("a")
        .removeClass("active")
        .removeAttr("tabindex");
      a.addClass("active").attr("tabindex", "-1");
    });

    minutes.on("click", function (e) {
      var a = $(e.currentTarget);
      if (a.hasClass(".active") || a.hasClass("xt-disabled")) {
        return;
      }
      var time = me.time || [0, 0];
      time[1] = me.intType(a.text());
      me.setval(time, true);
      me.disableMin();
      a.siblings("a")
        .removeClass("active")
        .removeAttr("tabindex");
      a.addClass("active").attr("tabindex", "-1");

      $(document).click();
    });

    dropdown.find("a.close").on("click", function () {
      $(document).click();
    });
  },
  disableMin: function () {
    var me = this,
      dropdown = me.dropdown;

    if (!dropdown) {
      return;
    }

    var el = me.el,
      data_min = el.data("min") || "00:00",
      data_max = el.data("max") || "24:00",
      min = me.intType(data_min.split(":")),
      max = me.intType(data_max.split(":")),
      minutes = dropdown.find("div.minutes > a");

    minutes.removeClass("xt-disabled").removeAttr("tabindex");
    if (me.time && (me.time[0] == min[0] || me.time[0] == max[0])) {
      var which;
      if (me.time[0] == min[0]) {
        $.each(minutes, function (i, el) {
          if (me.intType($(el).text()) < min[1]) {
            $(el)
              .addClass("xt-disabled")
              .attr("tabindex", "-1");
          }
        });
        which = "first";
      }
      if (me.time[0] == max[0]) {
        $.each(minutes, function (i, el) {
          if (me.intType($(el).text()) > max[1]) {
            $(el)
              .addClass("xt-disabled")
              .attr("tabindex", "-1");
          }
        });
        which = "last";
      }

      var axtivext = dropdown.find("div.minutes > a.active.xt-disabled")[0];
      if (axtivext) {
        var element = dropdown.find(
          "div.minutes > a:not(.xt-disabled):" + which
        ),
          time = me.time;
        $(axtivext).removeClass("active");
        time[1] = me.intType(element.text());
        me.setval(time);
        element.addClass("active");
      }
    }
  },
  inputvalid: function (time, change) {
    var me = this,
      el = me.el,
      timeint = me.intType(time),
      MIN = el.data("min") || "00:00",
      min = MIN.split(":"),
      MAX = el.data("max") || "100:00",
      max = MAX.split(":"),
      newtime;

    min = me.intType(min);
    max = me.intType(max);

    if (!timeint[0] && !timeint[1]) {
      timeint[0] = min[0];
      timeint[1] = min[1];
    } else if (!timeint[0]) {
      timeint[0] = min[0];
    } else if (!timeint[1]) {
      timeint[1] = timeint[0] <= min[0] ? min[1] : 0;
    }

    if (timeint[0] < min[0] || (timeint[0] <= min[0] && timeint[1] < min[1])) {
      newtime = "";
      el.parents(".xmat-field").addClass("input-wrong wrong-time");
    } else if (
      timeint[0] > max[0] ||
      (timeint[0] >= max[0] && timeint[1] > max[1])
    ) {
      newtime = "";
      el.parents(".xmat-field").addClass("input-wrong wrong-time");
    } else if (timeint[1] > 59) {
      newtime = "";
      el.parents(".xmat-field").addClass("input-wrong wrong-format");
    } else {
      newtime = me.stringType(timeint[0]) + ":" + me.stringType(timeint[1]);
    }

    me.setval(
      newtime === "" ? undefined : me.intType(newtime.split(":")),
      change
    );
    me.disableMin();
  },
  stringType: function (i) {
    var nr = i.toString();
    nr = nr.length == 1 ? "0" + nr : nr;
    return nr;
  },
  intType: function (a) {
    if (a instanceof Array) {
      var arr = a.map(function (x) {
        return parseInt(x, 10);
      });
      return arr;
    } else {
      return parseInt(a, 10);
    }
  },
};

var x_controls = function () { },
  x_buttons = function () { };

x_controls.prototype = {
  init: function () {
    var me = this,
      not = '.control--rendered, [type="hidden"]';

    $("a:not(" + not + ")").each(function (e) {
      var button = $(this);
      switch (button.data("type")) {
        case "xaction":
          me.xaction(button);
          break;
        case "xdownload":
          me.xdownload(button);
          break;
        default:
          break;
      };

      button.addClass("control--rendered");
    });

    $("input:not(" + not + ")").each(function (e) {
      var input = $(this);
      switch (input.data("type")) {
        case "xdaterange":
          me.xdaterange(input);
          break;
        case "xusername":
          me.xusername(input);
          break;
        case "xpassword":
          me.xpassword(input);
          break;
        case "xautocomplete":
          me.xautocomplete(input);
          break;
        case "xradio":
          me.xradio(input);
          break;
        case "xnumber":
          me.xnumber(input);
          break;
        case "xname":
          me.xname(input);
          break;
        case "xmoney":
          me.xmoney(input);
          break;
        case "xdate":
          me.xdate(input);
          break;
        case "xdateinline":
          me.xdateinline(input);
          break;
        case "xfile":
          //debugger;
          new xfileinput().init(input);
          break;
        case "xtime2":
          new xtime2().init(input);
          break;
        case "xdate":
          break;
        case "xtime":
          me.xtime(input);
          break;
        case "ximage":
          me.ximage(input);
          break;
        case "xswitch":
          me.xswitch(input);
          break;
        case "xphone":
          me.xphone(input);
          break;
        case "xiban":
          me.xiban(input);
          break;
        case "xmail":
          me.xmail(input);
          break;
        case "xurl":
          me.xurl(input);
          break;
        case "xalias":
          me.xalias(input);
          break;
        case "xcheckboxgroup":
          me.xcheckboxgroup(input);
          break;
        default:
          break;
      }

      input.addClass("control--rendered");
    });

    $("select:not(" + not + ", .custom, .swal2-select)").each(function (
      e
    ) {
      var select = $(this);
      switch (select.data("type")) {
        case "simple":
        case "remote":
          me.xselect(select);
          break;
        case "grouping":
          me.xselect_grouping(select);
          break;
        case "multi":
          me.xselect_multi(select);
          break;
        default:
          select.select2();
          break;
      }

      select.addClass("control--rendered");
    });

    $("textarea:not(" + not + ")").each(function (e) {
      var textarea = $(this);

      switch (
      textarea.data("type") // type ?
      ) {
        case "simple":
          me.xtextarea_simple(textarea);
          break;
        case "pro":
          me.xtextarea_pro(textarea);
          break;
        default:
          me.xtextarea(textarea);
          break;
      }

      textarea.addClass("control--rendered");
    });

    $("div.xmega:not(.rendered)").each(function (i, el) {
      new xmega().init($(el));
    });

    return me;
  },
  xaction: function (button) {
    var data = button.data();

    let jsonSave = function (checked) {
      let result = Object.assign(data.data, { checked: checked })

      xcrud.json.save(data.submit,
        result,
        data.callback,
        {
          url: data.url,
          disablenotify: data.disablenotify
        }
      );
    }

    button.on('click', function (e) {
      let checked = button.closest('.xgrid')[0] ? button.closest('.xgrid')[0].xgrid.getCheckedValues() : null;

      if (data.question !== undefined) {
        xdialog.question.show(data.question, function (confirm) {
          if (!confirm) {
            return;
          }
          jsonSave(checked);
        });
      } else {
        jsonSave(checked);
      }

    });
  },

  xdownload: function (me) {
    var data = me.data();
    console.log(data);
    if (data.url) {
      me.on('click', function (e) {

        let checked = me.closest('.xgrid')[0] ? me.closest('.xgrid')[0].xgrid.getCheckedValues() : null;
        let checkedarr = checked.split(',')
        checkedarr.forEach(function (val) {
          xhelper.file.download(data.url, {
            pk: data.pk,
            checked: val
          });
        });
      });
    }
  },

  xalias: function (me) {

  },
  xradio: function (input) {
    var data = input.data(),
      control = $("div#" + data.control);

    if (control.length > 0) {
      var f = function (control) {
        return function (e) {
          var elements = $("input[name=" + $(this).attr("name") + "]").not(
            $(this)
          );

          elements.each(function (e) {
            var cont = $("div#" + $(this).data("control"));
            cont.addClass("d-none");

            cont.find(":input").attr("disabled", true);
          });
          control.removeClass("d-none");
          control.find(":input").attr("disabled", false);
        };
      };

      if (control.hasClass("d-none")) {
        control.find(":input").attr("disabled", true);
      }

      input.on("change", f(control));
    }
  },
  xmoney: function (input) {
    this.xnumber(input);
    $(input).on("keypress", function (e) {
      if (e.which == 44) {
        //$(input).val().replace(/\,/g, '.');;
      }
    });
  },
  xnumber: function (input) {
    var data = input.data(),
      control = $("input[name=" + data.control + "]"),
      val = parseFloat(input.val());

    input.inputmask();

    if (control.length > 0) {
      var f = function (control) {
        return function (e) {
          var t = parseFloat($(this).val()),
            c = parseFloat(control.val());

          //control.attr('min', t);
          control.rules("remove", "min");
          control.rules("add", {
            min: t,
          });

          if (t > c) {
            control.val(null);
          }
        };
      };

      input.on("change", f(control));

      if (val) {
        control.rules("remove", "min");
        control.rules("add", {
          min: val,
        });
      }
    }
  },
  xdate: function (input) {
    var data = input.data(),
      control = $("input[name='" + data.control + "']");
    val = input.val();
    if (control.length > 0) {
      var f = function (control) {
        return function (e) {
          var t = $(this).val(),
            c = control.val();

          control.datepicker("setStartDate", t);

          var diff = moment(t).diff(c, "days");
          if (diff > 0) {
            control.val(null);
          }
        };
      };

      input.on("change", f(control));

      control.datepicker("setStartDate", val);
    }
  },
  xdateinline: function (input) {
    $(input).hide();

    var dateInput = $(input.parent()),
      data = input.parent().data(),
      showTodayBtn = data.todayButton,
      startDate = data.startDate,
      endDate = data.endDate,
      endDateDay = moment(endDate, "YYYY-MM-DD").date(),
      endDateMonth = moment(endDate, "YYYY-MM-DD").month() + 1,
      endDateYear = moment(endDate, "YYYY-MM-DD").year(),
      todayHighlight = data.highlight,
      viewMode = data.viewmode,
      disableWeeks = data.disableWeekdays,
      url = data.url,
      pk = data.pk,
      value = input.val(),
      init = false;

    dateInput.on("changeMonth", function (e) {

      setTimeout(function () {
        dateInput.find("td.day").wrapInner('<div class="day-content"></div>');
      }, 100);

      var date = e.date || value || new Date(),
        month = moment(date).format("MM"),
        year = moment(date).format("YYYY");
      //debugger;
      if (month == endDateMonth) {
        //dateInput.find('th.next').prop('disabled', true);
        dateInput.find("th.next").prop("disabled", true).addClass("arrowDisabled");
      } else {
        dateInput.find("th.next").prop("disabled", false).removeClass("arrowDisabled");
      }

      xcrud.json.load(
        url, {
        year: year,
        month: month,
        pk: pk,
      },
        function (response, data) {
          init = true;
          dateInput.disabled = response.disabled;
          dateInput.enabled = response.enabled;
          dateInput.colors = response.colors;
        },
        false
      );
    })
      .on("show", function (e) {
        if (init === false) {
          dateInput.datepicker().trigger("changeMonth");
          dateInput.datepicker("update");
        }
        //dateInput.find('td.day').wrapInner('<div class="day-content"></div>');
      })
      .datepicker({
        language: "lt",
        inline: true,
        calendarWeeks: true,
        todayHighlight: todayHighlight,
        todayBtn: showTodayBtn,
        startDate: startDate,
        endDate: endDate,
        maxViewMode: viewMode,
        updateViewDate: true,
        format: "yyyy-mm-dd",
        beforeShowDay: function (e) {
          if (!dateInput.disabled) {
            return;
          }
          var disabled = dateInput.disabled,
            enabled = dateInput.enabled,
            colors = dateInput.colors,
            date = moment(e).format("YYYY-MM-DD");

          if (colors) {
            var obj = {
              enabled: !disabled[date],
              tooltip: disabled[date] || enabled[date],
              classes: colors[date],
            };
          } else {
            var obj = {
              enabled: !disabled[date],
              tooltip: disabled[date] || (enabled[date] ? enabled[date][0] : ""),
            };
          }

          return obj;
        },
        beforeShowMonth: function (date) {
          dateInput.find("td.day[title]").each(function (i, el) {
            $(el).attr("data-tooltip", $(el).attr("title"));
            xdialog.tooltip.show($(el));
          });

          if (disableWeeks) {
            dateInput.find("td.cw").hide();
            dateInput.find("th.cw").hide();
            dateInput.find("th.datepicker-switch").attr("colspan", 5);
          }

          dateInput.find("td.disabled").on("click", function (e) {
            xdialog.notify.show("Bilietų nėra", "", "danger");
          });
        },
      })
      .on("changeDate", function (e) {
        var enabled = dateInput.enabled,
          rangeInput = $("#ArrivalTime"),
          subInput = data.subinput,
          clickedDate = moment(e.date).format("YYYY-MM-DD");
        // xlog(clickedDate);
        if (subInput) {
          rangeInput.empty().append("<option value selected disabled>Pasirinkite...</option>");

          $.each(enabled[clickedDate][1], function (i, item) {
            rangeInput.append(
              $("<option>", {
                value: item.id,
                text: item.Name,
              })
                .attr("data-address", item.Address)
                .attr("data-confirmation", item.Confirmation)
                .attr("data-applicationscheduleid", item.ApplicationScheduleId)
            );
          });
        }
        dateInput.find("td.day").wrapInner('<div class="day-content"></div>');
        $("#ArrivalDateHiddenText")
          .html(enabled[clickedDate][0])
          .text();
      });
  },
  xdaterange: function (daterange) {
    daterange.daterangepicker({
      autoUpdateInput: false,
      ranges: {
        "Šis mėnesis": [moment().startOf("month"), moment().endOf("month")],
        "Praėjęs mėnesis": [
          moment()
            .subtract(1, "month")
            .startOf("month"),
          moment()
            .subtract(1, "month")
            .endOf("month"),
        ],
        "Šis ketvirtis": [
          moment().startOf("quarter"),
          moment().endOf("quarter"),
        ],
        "Praėjęs ketvirtis": [
          moment()
            .subtract(3, "months")
            .startOf("quarter"),
          moment()
            .subtract(3, "months")
            .endOf("quarter"),
        ],
        "Šis pusmetis": [
          moment()
            .startOf("year")
            .add(6, "months"),
          moment().endOf("year"),
        ],
        "Praėjęs pusmetis": [
          moment().startOf("year"),
          moment()
            .endOf("year")
            .subtract(6, "months"),
        ],
        "Šie metai": [moment().startOf("year"), moment().endOf("year")],
        "Praėję metai": [
          moment()
            .subtract(1, "year")
            .startOf("year"),
          moment()
            .subtract(1, "year")
            .endOf("year"),
        ],
      },
      alwaysShowCalendars: false,
    },
      function (start, end, label) {
        var inputVal =
          start.format(this.locale.format) +
          " - " +
          end.format(this.locale.format);
        daterange
          .val(inputVal)
          .closest(".daterange-picker")
          .find(".daterange-select-text")
          .text(label);
        daterange
          .closest(".daterange-picker")
          .find(".daterange-text")
          .removeClass("text-muted")
          .text(inputVal);
      }
    );
  },
  xmail: function (input) {
    input.on("input", function (e) {
      var value = input.val();
      input.val(value.replace(/^\s+|\s+$/g, ""));
      //$.trim(input.val().toLowerCase())
    });
  },
  xusername: function (input) {
    input.on("input", function (e) {
      input.val($.trim(input.val()));
    });
  },
  xpassword: function (input) {
    var data = input.data(),
      showSuggestions = data.showInfo;

    if (showSuggestions) {
      $('input[type="password"]').tooltipster({
        trigger: "click",
        content: $("#pswd_info"),
        contentAsHTML: true,
        theme: ["tooltipster-white"],
        side: ["bottom", "top"],
      });
    }

    input.on("input", function (e) {
      input.val($.trim(input.val()));

      var pswd = input.val();
      if (pswd.length < 6) {
        $("#length")
          .removeClass("valid")
          .addClass("invalid");
        $("#length .fa.fa-check").toggleClass("fa fa-check fa fa-times");
      } else {
        $("#length")
          .removeClass("invalid")
          .addClass("valid");
        $("#length .fa.fa-times").toggleClass("fa fa-times fa fa-check");
      }

      if (pswd.match(/[A-z]/)) {
        $("#letter")
          .removeClass("invalid")
          .addClass("valid");
        $("#letter .fa.fa-times").toggleClass("fa fa-times fa fa-check");
      } else {
        $("#letter")
          .removeClass("valid")
          .addClass("invalid");
        $("#letter .fa.fa-check").toggleClass("fa fa-check fa fa-times");
      }

      //validate capital letter
      if (pswd.match(/[A-Z]/)) {
        $("#capital")
          .removeClass("invalid")
          .addClass("valid");
        $("#capital .fa.fa-times").toggleClass("fa fa-times fa fa-check");
      } else {
        $("#capital")
          .removeClass("valid")
          .addClass("invalid");
        $("#capital .fa.fa-check").toggleClass("fa fa-check fa fa-times");
      }

      //validate number
      if (pswd.match(/\d/)) {
        $("#number")
          .removeClass("invalid")
          .addClass("valid");
        $("#number .fa.fa-times").toggleClass("fa fa-times fa fa-check");
      } else {
        $("#number")
          .removeClass("valid")
          .addClass("invalid");
        $("#number .fa.fa-check").toggleClass("fa fa-check fa fa-times");
      }

      //validate special character
      if (pswd.match(/[\!\@\#\$\%\^\&\*\?\_\~\-\(\)]+/)) {
        $("#special")
          .removeClass("invalid")
          .addClass("valid");
        $("#special .fa.fa-times").toggleClass("fa fa-times fa fa-check");
      } else {
        $("#special")
          .removeClass("valid")
          .addClass("invalid");
        $("#special .fa.fa-check").toggleClass("fa fa-check fa fa-times");
      }
    });
  },
  xurl: function (input) {
    input.on("input", function (e) {
      input.val(input.val().toLowerCase());
      input.val($.trim(input.val()));
    });
  },
  xfile: function (input) {
    input.addClass("xfile-rendered");
    new xfileinput().init(input);
  },
  xselect: function (select) {

    var data = select.data(),
      url = data.url,
      form = select.closest('form'),
      controlSelector = `select[name=${data.control}]`,
      listenSelector = `select[name=${data.listen}]`,
      //listen = $("select[data-control='" + select.attr("name") + "']"),
      listen = form ? form.find(listenSelector) : $(listenSelector),
      control = form ? form.find(controlSelector) : $(controlSelector),
      val = data.value,
      extra = data.extra ? "&extra=" + data.extra : "",
      clearOption = data.allowClear,
      dataset = data.dataset,
      tags = data.newoptions,
      oldName = select.attr('name'),
      newName = data.newname,
      layoutElementId = data.layoutElementId,
      events = xhelper.element.events(select); //jei yra change

    if (data.type == 'simple') {
      return select.select2({
        allowClear: clearOption,
        placeholder: ""
      });
    }

    $.fn.setValue = function (id, text) {
      $(this).select2("trigger", "select", {
        data: {
          id: id,
          text: text,
        },
      });
    };

    // on click - query formavimas
    var queryFunction = function (listen, dataset) {
      return function (params) {
        var query = {
          term: params.term,
          _dataset: dataset,
          layoutElementId: layoutElementId,
          pk: pk,
          extra: data.extra
        };

        // klausosi kito select
        if (listen.length > 0) {
          var key = listen.data("listen-key");
          //debugger;
        }

        query[key] = listen.val();

        return query;
      };
    };

    var initSelect = function (select, ajax) {
      select.select2({
        ajax: ajax,
        allowClear: clearOption,
        placeholder: "",
        tags: tags,
        createTag: function (params) {
          // :contains ims dabar ir uppercased ir lowercased
          jQuery.expr[':'].contains = function (a, i, m) {
            return jQuery(a).text().toUpperCase()
              .indexOf(m[3].toUpperCase()) >= 0;
          };

          var term = $.trim(params.term);
          let results = $('.select2-results').find('li:contains(' + term + ')').length,
            tagName = select.attr('data-tagName');

          if (term === '') {
            return null;
          }

          if (results == 0) {
            select.attr('name', newName);
            return {
              id: term,
              text: term + ' ' + tagName,
              newTag: true
            }
          }
        }
      })
        .on("select2:selecting", function (ev) {
          var params = ev.params.args.data;
          ev.preventDefault();
          select.empty();
          select.append(
            '<option value="' +
            params.id +
            '" selected>' +
            params.text +
            "</option>"
          );
          select.select2("close");
          select.trigger("change", params);
        })
        .on("select2:open", function () {
          select.attr('name', oldName);
        });
    }
    var ajax = {
      delay: 250,
      url: url,
      dataType: "json",
      data: queryFunction(listen, dataset)
    };

    // yra nustatytas `value` - daromas query
    if (val) {
      var c = $.extend({}, ajax, {
        url: ajax.url + "?_dataset=" + dataset + "&id=" + val + extra,
        success: function (e) {
          var result = e.results[0];

          if (result) {
            select.append(
              '<option value="' +
              result.id +
              '" selected="selected">' +
              result.text +
              "</option>"
            );
          }
          initSelect(select, ajax);

          /* select.select2({
            ajax: ajax,
            allowClear: clearOption,
            placeholder: "",
          }); */
        },
      });
      $.ajax(c);
    } else {
      initSelect(select, ajax);
    }

    // valdo kita select
    var controlFunction = function (control) {
      return function (e) {
        control.val(null).trigger("change.select2");
        control.trigger({
          type: "change",
          params: {
            data: [null, null],
          },
        });
      };
    };

    if (control) {
      // select.on("select2:select", controlFunction(control, listen);

      select.on("change", controlFunction(control));
    }
  },
  xselect_multi: function (select) {
    var form = select.parent().parent();

    select.select2({
      closeOnSelect: false,
    });

    form.on("submit", function (e) {
      // alert('lab');
    });
  },
  xselect_grouping: function (select) {
    var data = select.data(),
      url = data.url,
      dataset = data.dataset;

    select.select2({
      ajax: {
        url: url + "?_dataset=" + dataset,
        dataType: 'json',
        delay: 250,
        data: function (params) {
          return {
            term: params.term
          }
        }
      },
      cache: true
    });

    // Issaugojimas search termo, po select2 uzdarymo
    var currentQuery;
    select.on('select2:open', function () {
      setTimeout(function () {
        if (currentQuery && currentQuery.length) {
          $('.select2-search input').val(currentQuery).trigger('input');
        };
      }, 0);
    }).on('select2:closing', function () {
      currentQuery = $('.select2-search input').prop('value');
    });
  },
  xautocomplete: function (input) {
    input.autocomplete({
      source: input.data("url"),
      minLength: 3,
    });
  },
  xtime: function (input) {
    // if(input.data('mintime')) {
    //     var minTime = Math.abs(input.data('mintime').split(':')[0]);
    // }
    var timeLock = $("#TimeStart").val() ?
      Math.abs(
        $("#TimeStart")
          .val()
          .split(":")[0]
      ) :
      undefined,
      timeEndHours = $("#TimeEnd").val() ?
        Math.abs(
          $("#TimeEnd")
            .val()
            .split(":")[0]
        ) :
        undefined,
      timeEndMin = $("#TimeEnd").val() ?
        Math.abs(
          $("#TimeEnd")
            .val()
            .split(":")[1]
        ) :
        undefined;

    var pickerConfig = {
      max_hour_value: 24,
      show_meridian: false,
      min_hour_value: 0,
      on_change: function () {
        if (input.is("#TimeStart")) {
          var timeBl = $("#TimeStart").attr("data-timepicki-tim"),
            timeMin = $("#TimeStart").attr("data-timepicki-mini"),
            timeParent = $("#TimeEnd")
              .parent()
              .closest(".input-group"),
            timeInput = $("#TimeEnd"),
            timeVal = $("#TimeStart").val();
          timeParent
            .closest(".input-group")
            .empty()
            .append(timeInput);
          timeInput.timepicki({
            max_hour_value: 24,
            show_meridian: false,
            min_hour_value: timeBl,
            start_time: [timeBl, timeMin],
          });
          timeInput.attr("data-timepicki-tim", timeEndHours);
          timeInput.attr("data-timepicki-mini", timeEndMin);
          $("#TimeEnd")
            .next()
            .find(".timepicki-input")
            .attr("disabled", "disabled");
        }
      },
    },
      val = input.val(),
      h = input.data("hours"),
      m = input.data("minutes");
    //debugger;
    if (val) {
      pickerConfig["start_time"] = [h, m];
    }
    input.timepicki(pickerConfig);
    $("#TimeStart")
      .next()
      .find(".timepicki-input")
      .attr("disabled", "disabled");
    $("#TimeEnd")
      .next()
      .find(".timepicki-input")
      .attr("disabled", "disabled");
  },
  xname: function (input) {
    // input.on('keyup', function(e) {
    //     var val = input.val(),
    //         spart = val.split(" "),
    //         capsPressed = false, // e.which = 20
    //         shiftPressed = false; // e.which = 16

    //     if(e.which == 20) {
    //         capsPressed = true;
    //     } else if (e.which == 16) {
    //         shiftPressed = true;
    //     }

    //     for (var i = 0; i < spart.length; i++) {
    //         var j = spart[i].charAt(0).toUpperCase();
    //         spart[i] = j + spart[i].substr(1);
    //     }
    //     $(input).val(spart.join(" "));

    // });

    /* input.data('rule-pattern', '(^[a-zA-ZąčęėįųūżčšžĄČĖĘĮŲŪČŠŽ\s]*$)');
    input.data('msg', 'Netinkamai įvestas vardas arba pavardė'); */

    input.on("keyup", function (e) {
      var val = input.val(),
        spart = val
          .split(" ")
          .map(function (word) {
            return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
          })
          .join(" ");

      $(this).val(spart);
    });

    input.on("focusout", function (e) {
      input.val($.trim(input.val()));
    });
  },
  ximage: function (input) {
    $(input).change(function (e) {
      var reader = new FileReader(),
        file = e.target.files[0],
        el = $(e.currentTarget).closest(".ximage"),
        filename = el.find(".ximage-filename"),
        preview = el.find(".ximage-preview");

      reader.onloadstart = function (data) {
        if (file.type.match("image.*")) {
          loader.start("upload", file.size, preview);
          preview.collapse("show");
        } else {
          xdialog.notify.show(
            "Klaida",
            "Pasirinktas failas nėra nuotrauka",
            "warning"
          );
          reader.abort();
          preview.collapse("hide");
        }
      };

      reader.onprogress = function (data) {
        if (data.lengthComputable) {
          loader.updateProgress(data.loaded);
        }
      };

      reader.onloadend = function () {
        setTimeout(function () {
          loader.stop();
        }, 500);
      };

      reader.addEventListener(
        "load",
        function () {
          //preview.css('background-image', 'url(' + reader.result + ')');
          xhelper.image.getOrientation(reader, file, function (orientation) {
            xhelper.image.resetOrientation(reader.result, orientation, function (
              resetBase64Image
            ) {
              preview.css("background-image", "url(" + resetBase64Image + ")");
            });
          });
        },
        false
      );

      if (file) {
        reader.readAsDataURL(file);
        filename.val(file.name);
      }
    });
  },
  xswitch: function (input) {
    var label = input.nextAll("label:eq(1)"),
      labelOn = label.data("controlOn"),
      labelOff = label.data("controlOff");

    input.on("change", function (e) {
      label.text(input.is(":checked") === true ? labelOn : labelOff);
    });
  },
  xtextarea_simple: function (textarea) {
    var selectorId = $(textarea)[0].id;
    tinyMCE.suffix = ".min";
    tinymce.init({
      selector: "#" + selectorId,
      statusbar: false,
      menubar: false,
      plugins: "paste autolink image code link table media autoresize lists",
      autoresize_max_height: 500,
      toolbar: "undo redo | bold italic underline | alignleft aligncenter alignright | numlist bullist",
      paste_data_images: true,
      default_link_target: "_blank",
      images_reuse_filename: true,
      relative_urls: false,
      setup: function (editor) {
        editor.on("change", function () {
          editor.save();
        });
      },
    });
  },
  xtextarea_pro: function (textarea) {
    var selectorId = $(textarea)[0].id;
    tinyMCE.suffix = ".min";

    // tinymce.baseURL = '/vendor/node/tinymce';

    tinymce.init({
      selector: "#" + selectorId,
      height: 200,
      plugins: [
        "advlist autolink lists link image charmap print preview hr anchor pagebreak",
        "searchreplace wordcount visualblocks visualchars code fullscreen",
        "insertdatetime media save table directionality",
        "emoticons paste textpattern code imagetools", // template, nonbreaking
      ],
      table_toolbar: "tableprops tabledelete | tableinsertrowbefore tableinsertrowafter tabledeleterow | tableinsertcolbefore tableinsertcolafter tabledeletecol",
      table_default_styles: {
        width: "100%",
      },
      menubar: true,
      toolbar1: "undo redo | bold italic underline | fontselect fontsizeselect formatselect | alignleft aligncenter alignright alignjustify | numlist bullist",
      toolbar2: " | link unlink | image media | forecolor backcolor  | preview code",
      urlconverter_callback: function (url) {
        return url;
      },

      filemanager_title: "Failų tvarkyklė",
      paste_data_images: true,
      relative_urls: false, // del image upload
      images_upload_url: "/files/upload_photo_mce",
      default_link_target: "_blank",
      image_advtab: true,
      anchor_bottom: false,
      anchor_top: false, // iterpri -> nuoroda nebeatsiranda dropdown ant pirmo input lauko
      paste_word_valid_elements: "b,strong,i,em,h1,h2,u,p,ol,ul,li,a[href],span,color,font-size,font-color,font-family,mark,table,tr,td",
      // base: '/vendor/js/tinymce',
      language: 'lt',
      setup: function (editor) {
        editor.on("change", function () {
          editor.save();
        });
      },
    });
  },
  xtextarea: function (textarea) {
    var maxlength = textarea.attr("maxlength"),
      currentLength = textarea.val().length;

    textarea
      .parent()
      .next(".charNum")
      .text("Liko " + (maxlength - currentLength) + " simbolių")
      .css("color", "black");

    textarea.on("input", function () {
      var maxlength = $(this).attr("maxlength"),
        currentLength = $(this).val().length;

      if (currentLength >= maxlength) {
        $(this)
          .parent()
          .next(".charNum")
          .text("Liko 0 simbolių")
          .css("color", "red");
      } else {
        $(this)
          .parent()
          .next(".charNum")
          .text("Liko " + (maxlength - currentLength) + " simbolių")
          .css("color", "black");
      }
    });

    var el = textarea.get(0);
    var setHeight = function () {
      if (el.clientHeight < el.scrollHeight) {
        el.style.height = el.scrollHeight + 15 + 'px';
      }
    }

    el.style.overflow = 'hidden';

    setHeight();

    textarea.on('keydown', function () {
      setHeight();
    });
  },
  xphone: function (input) {
    var label = $(input).next(),
      listLT = $.masksSort(
        $.masksLoad("/static/dist/registers/json/phones-lt.json"),
        ["#"],
        /[\+0-9]|#/,
        "mask"
      ),
      me = $(this);

    var maskOpts = {
      inputmask: {
        definitions: {
          "#": {
            validator: "[+0-9]",
            cardinality: 1,
          },
        },
        showMaskOnHover: false,
        showMaskOnFocus: false,
        autoUnmask: true,
        jitMasking: true,
        keepStatic: false,
      },
      match: /[\+0-9]/,
      replace: "#",
      listKey: "mask",
    };

    var maskChangeLT = function (maskObj, determined, completed) {
      if (determined) {
        if (maskObj.type != "mobile") {
          label.html(
            maskObj.city.toString() + " " + maskObj.region.toString() + " "
          );
        } else {
          label.html("Mobilus numeris");
        }
      } else {
        label.html("Maskuoti inputą");
      }
    };

    $(input).inputmasks(
      $.extend(true, {}, maskOpts, {
        list: listLT,
        onMaskChange: maskChangeLT,
      })
    );

    $(input).on("keyup", function (e) {
      var value = $(input).val(),
        firstValue = value.substring(0, 1);
      if (firstValue == 8) {
        $(input).attr("minlength", "9");
      } else {
        $(input).attr("minlength", "12");
      }
    });
  },
  xiban: function (input) {
    var label = $(input)
      .parent()
      .next("label");
    var ibanListLT = $.masksSort(
      $.masksLoad("/static/dist/registers/json/iban-lt.json"),
      ["#"],
      /[\+0-9]|#/,
      "mask"
    );

    var maskOpts = {
      inputmask: {
        definitions: {
          "#": {
            validator: "[+0-9]",
            cardinality: 1,
          },
        },
        showMaskOnHover: true,
        autoUnmask: true,
        jitMasking: true,
      },
      match: /[\+0-9]/,
      replace: "#",
      listKey: "mask",
    };

    var maskChangeLT = function (maskObj, determined, completed) {
      if (determined) {
        label.html(
          maskObj.city.toString() + " " + maskObj.region.toString() + " "
        );
      }
    };

    $(input).inputmasks(
      $.extend(true, {}, maskOpts, {
        list: ibanListLT,
        onMaskChange: maskChangeLT,
      })
    );
  },
};

x_buttons.prototype = {
  search: {
    submit: function () { },
    clear: function () { },
  },
};

var xcontrols = new x_controls(),
  xbuttons = new x_buttons();